<template>
  <v-autocomplete
    v-model="localValue"
    :items="users"
    :label="localLabel"
    item-text="display"
    item-value="id"
    :search-input.sync="search"
    :required="required"
    :return-object="returnObject"
    clearable
    :multiple="multiple"
    :loading="loading"
    :menu-props="{
      closeOnContentClick: true
    }"
    :error-messages="errors"
  >
    <template v-slot:item="{ item }">
      <template v-if="item.type === 'header'">
        <v-list-item-content v-text="item.display"></v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-avatar size="32px">
          <img v-if="item.avatar" :src="item.avatar" />
          <v-icon v-else small>{{ $vuetify.icons.values.user }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="item.display"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { LIKE_OPERATOR } from '@argon/app/axios'

import { mapActions } from 'vuex'
import { CustomFieldMixin } from '@argon/app/mixins'
import { NAMESPACE as ORG_NAMESPACE } from '../organizations/store'

export default {
  name: 'UserField',
  mixins: [CustomFieldMixin],
  props: {
    provided: Array,
    multiple: { type: Boolean, default: false },
    returnObject: { type: Boolean, default: false }
  },
  data: () => ({
    search: null,
    loading: false,
    users: [],
    pager: { per_page: -1 }
  }),
  watch: {
    search: function (v) {
      if (v && v.length > 2) {
        this.getUsers(v)
      }
    }
  },
  methods: {
    ...mapActions(ORG_NAMESPACE, ['fetchCurrentOrgUsers']),
    getUsers(value) {
      if (this.provided) {
        this.users = this.provided.filter((x) => x.display.includes(value))
      } else {
        const filters = `display:${LIKE_OPERATOR}:${value}`
        this.loading = true
        this.fetchCurrentOrgUsers({ pager: this.pager, filters })
          .then(({ items }) => {
            this.users = items.map((item) => item.user)
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  },
  computed: {
    localLabel() {
      return this.label || this.$t('labels.user')
    }
  },
  created() {
    if (this.provided) {
      this.users = this.provided
    }
  }
}
</script>
